import React from "react";

export default function CreateNewRecipientButton(props) {
  return (
    <div id="createUserButtonWrapper">
      <button type="button" id="createOrRequestBtn" onClick={props.onClick}>
        + &nbsp; Create Subscription
      </button>
    </div>
  );
}
